// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-app>
    <v-navigation-drawer app clipped persistent v-model="showDrawer" style="z-index: 1000;">
      <v-list subheader dense style="padding: 0px;">
        <v-list-item>
          <v-list-item-content>
            <img v-bind:src="'static/logo.svg'" style="width: 100%; padding-top: 8px;">
          </v-list-item-content>

          <v-list-item-action v-if="isMobile">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon text v-on="on" slot="activator"><v-icon x-large>account_circle</v-icon></v-btn>
              </template>
              <v-list>
                <v-list-item :to="{name: 'userMe'}">
                  <v-list-item-title>Profile</v-list-item-title>
                </v-list-item>
                <v-list-item @click="logout">
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
        </v-list-item>

        <v-list-item style="background-color: rgba(0,0,0,0.07);">
          <v-list-item-content>
            <v-menu>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" slot="activator">{{ selectedSite.name || 'Site' }}<v-icon v-if="sites.length > 1">arrow_drop_down</v-icon></v-btn>
              </template>
              <v-list>
                <v-list-item v-for="item in sites" :key="item._id" @click="setSite(item)">
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-content>
        </v-list-item>
        <template v-if="!isLoading">
          <template v-for="(item, i) in menu">
            <template v-if="item.items">
              <v-list-group v-if="item.items" :key="i">
                <template v-slot:activator>
                <!-- <v-list-item> -->
                  <v-list-item-action>
                    <v-icon>{{ item.action }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                <!-- </v-list-item> -->
                  </template>
                <v-list-item v-for="subItem in item.items" :key="subItem.title" :to="subItem.to">
                  <v-list-item-action> </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>{{ subItem.action }}</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>
            <template v-else>
              <v-list-item :to="item.to" :key="i">
                <v-list-item-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </template>
        <v-list-item style="background-color: rgba(0,0,0,0.07);">
          <v-list-item-action>
            <v-icon></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>v{{ version }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar v-if="showToolbar" app clipped-left clipped-right fixed style="max-height:56px;">
      <v-app-bar-nav-icon @click.stop="showDrawer = !showDrawer" class="ml-1 mb-2"></v-app-bar-nav-icon>
      <v-app-bar-title
      v-if="!isMobile"
      class="mr-6 text-no-wrap"
      style="min-width: 90px;">
      <div class="mr-6 mb-2">TallyFlow</div>
      </v-app-bar-title>

      <search-bar v-if="showPhotoSearch" :categories="getCategories"></search-bar>
      <template v-else>
        <v-text-field
          style="width:50%; margin-top:0%; margin-left:0%; margin-right: 1%; padding-top: 0%; max-height:100%;"
          solo
          text
          prepend-icon="search"
          append-icon="clear"
          @click:append="(event) => clearSearch()"
          v-model="searchBarText">
        </v-text-field>
      </template>

      <v-menu offset-y v-if="!isMobile">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-1 mb-1" icon text v-on="on" slot="activator"><v-icon x-large>account_circle</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item :to="{name: 'userMe'}">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <router-view :searchBarText="searchBarText"></router-view>
    </v-main>
    <v-footer style="height: 82px; background-color: #fafafa; z-index:-1;">
    </v-footer>

  </v-app>
</template>

<script>
import { removeCookie } from 'tiny-cookie'

import ApiRequests from '@/api/ApiRequests'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {PERMISSIONS} from '@sdgsystems/vue-common/components/constants'
import {checkPermission} from '@sdgsystems/vue-common/components/user'
import {AXIOSAPI} from '@sdgsystems/vue-common/components/requests-common'
import {version} from '../../package.json'
import SearchBar from 'photoservice-web/src/components/SearchBar'

export default {

  data () {
    return {
      forms: [],
      isLoading: true,
      maps: [],
      reportConfigs: [],
      showDrawer: true,
      showToolbar: true,
      sites: [],
      version: version,
      searchBarText: '',
      sSettings: {}
    }
  },

  components: {
    SearchBar
  },

  computed: {
    ...mapGetters([
      'accessRules',
      'filters',
      'getCategories',
      'selectedSite',
      'siteSettings'
    ]),

    adminMenu: function () {
      var adminMenuList = []

      if (checkPermission(this.accessRules, 'apikeys', PERMISSIONS.CREATE)) {
        adminMenuList.push({
          title: 'API Keys',
          to: { name: 'apikeys' },
          action: 'vpn_key'
        })
      }

      if (checkPermission(this.accessRules, 'image-categories', PERMISSIONS.MODIFY)) {
        adminMenuList.push({
          title: 'Categories',
          to: { name: 'categories' },
          action: 'folder'
        })
      }

      if (checkPermission(this.accessRules, 'reportconfigs', PERMISSIONS.MODIFY)) {
        adminMenuList.push({
          action: 'book_online',
          title: 'Report Configuration',
          to: { name: 'reportConfigs' }
        })
      }

      if (checkPermission(this.accessRules, 'sites', PERMISSIONS.MODIFY)) {
        adminMenuList.push({
          action: 'business',
          title: 'Sites',
          to: { name: 'sites' }
        })
      }

      if (checkPermission(this.accessRules, 'import', PERMISSIONS.MODIFY)) {
        adminMenuList.push({
          action: 'upload',
          title: 'Import',
          to: { name: 'importAsset' }
        })
        adminMenuList.push({
          action: 'upload',
          title: 'Import Zone',
          to: { name: 'importZone' }
        })
      }

      if (checkPermission(this.accessRules, 'users', PERMISSIONS.CREATE)) {
        adminMenuList.push({
          title: 'Users',
          to: { name: 'users' },
          action: 'group'
        })
      }

      if (checkPermission(this.accessRules, 'ssosettings', PERMISSIONS.CREATE) && this.showSSOSettings) {
        adminMenuList.push({
          title: 'SSO Settings',
          to: {name: 'ssoSettings'},
          action: 'group'
        })
      }

      if (checkPermission(this.accessRules, 'webhooks', PERMISSIONS.CREATE)) {
        adminMenuList.push({
          title: 'Webhooks',
          to: {name: 'webhooks'},
          action: 'phishing'
        })
      }

      return {
        action: 'build',
        title: 'Admin',
        items: adminMenuList
      }
    },

    configurationMenu: function () {
      var configurationMenuList = []

      if (checkPermission(this.accessRules, 'endpoints', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Endpoints',
          to: { name: 'endpoints' },
          action: 'settings_input_antenna'
        })
      }

      if (checkPermission(this.accessRules, 'locationtags', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Location Tags',
          to: { name: 'locationtags' },
          action: 'edit_location'
        })
      }

      if (checkPermission(this.accessRules, 'maps', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Maps',
          to: { name: 'maps' },
          action: 'map'
        })
      }

      if (checkPermission(this.accessRules, 'zones', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Zones',
          to: { name: 'zones' },
          action: 'flip_to_back'
        })
      }

      if (checkPermission(this.accessRules, 'orgsettings', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Organization Settings',
          to: { name: 'siteSettings' },
          action: 'settings'
        })
      }

      if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Organizations',
          to: { name: 'organizations' },
          action: 'filter_list'
        })
      }

      return {
        action: 'settings',
        title: 'Configuration',
        items: configurationMenuList
      }
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },

    menu: function () {
      var menu = []

      menu.push(
        {
          action: 'home',
          title: 'Home',
          to: { name: 'home' }
        },
        {
          action: 'access_alarm',
          title: 'Events',
          to: { name: 'events' }
        },
        {
          action: 'assignment',
          title: this.getItemLabel(),
          to: { name: 'items' }
        },
        {
          action: 'photo',
          title: 'Images',
          to: { name: 'images' }
        }
      )

      if (this.maps.length > 0) {
        var items = []
        for (const map of this.maps) {
          items.push({
            title: map.name,
            to: { name: 'mapView', params: { id: map._id }, query: { site: this.$route.query.site } }
          })
        }

        menu.push({
          action: 'map',
          title: 'Maps',
          items: items
        })
      }

      menu.push(
        {
          action: 'trending_up',
          title: 'Reports',
          items: [
            {
              title: 'Activity',
              to: { name: 'reportEvents' },
              action: 'view_agenda'
            },
            {
              title: 'Exceptions',
              to: { name: 'reportExceptions' },
              action: 'view_agenda'
            },
            {
              title: 'Zone Status',
              to: { name: 'reportZones' },
              action: 'view_agenda'
            },
            {
              title: 'Zones History',
              to: { name: 'reportZoneDurations' },
              action: 'view_agenda'
            },
            {
              title: 'Zone Categories',
              to: { name: 'reportZoneCategories' },
              action: 'view_agenda'
            }
          ]
        }
      )

      if (this.reportConfigs.length > 0) {
        var reports = []
        for (const item of this.reportConfigs) {
          reports.push({
            title: item.name,
            to: { name: 'reportEdit', params: { id: item._id }, query: { site: this.$route.query.site } }
          })
        }

        menu.push({
          action: 'trending_down',
          title: 'Custom Reports',
          items: reports
        })
      }

      if (!this.sSettings.hideWorkers) {
        menu.push({
          action: 'person',
          title: this.getWorkerLabel(),
          to: { name: 'workers' }
        })
      }

      if (this.adminMenu.items.length > 0) {
        menu.push(this.adminMenu)
      }

      if (this.configurationMenu.items.length > 0) {
        menu.push(this.configurationMenu)
      }

      return menu
    },

    showPhotoSearch: function () {
      if (this.$route.name === 'images') {
        return true
      }
      return false
    }
  },

  created () {
    // Hide the toolbar when rendering for print, otherwise show it.
    var mediaQueryList = window.matchMedia('print')
    mediaQueryList.addListener(mql => {
      if (mql.matches) {
        this.showDrawer = false
        this.showToolbar = false
      } else {
        this.showDrawer = true
        this.showToolbar = true
      }
    })

    window.Bus.$on('setSearchText', payload => {
      this.searchBarText = payload.searchText
    })

    this.getSiteSettings()
    this.getUserData()
    this.getSites()
    this.fetchCategories()
    this.isSSOAvailable()
  },

  beforeDestroy () {
    window.Bus.$off('setSearchText')
  },

  watch: {
    filters: function () {
      this.updatePath()
      this.getMaps()
      this.getReports()
    },

    '$route.name': function () {
      this.updatePath()
      if (!this.$route.name.includes('item')) {
        this.searchBarText = ''
      }
    },

    accessRules: function () {
      this.getSites()
    },

    siteSettings: function () {
      this.sSettings = this.siteSettings
      this.isLoading = false
    }
  },

  methods: {
    ...mapActions([
      'getUserData',
      'fetchCategories',
      'getSiteSettings'
    ]),

    ...mapMutations([
      'setSite'
    ]),

    checkPermission: function (item) {
      return checkPermission(this.accessRules, item, PERMISSIONS.MODIFY)
    },

    getSites: function () {
      ApiRequests.getSites().then(r => {
        this.sites = r.data
        if (this.sites.length > 0) {
          if (this.$route.query.site) {
            var site = this.sites.filter(e => e._id === this.$route.query.site)[0]
            if (site) {
              this.setSite(site)
            } else {
              this.setSite(this.sites[0])
            }
          } else {
            this.setSite(this.sites[0])
          }
        }
        this.updatePath()
      })
    },

    updatePath: function () {
      if (this.selectedSite && this.selectedSite._id) {
        var query = Object.assign({}, this.$route.query)
        if (query.site !== this.selectedSite._id) {
          query.site = this.selectedSite._id
          this.$router.replace({
            name: this.$route.name,
            query: query
          })
        }
      }
    },

    clearSearch: function () {
      this.searchBarText = ''
    },

    initialize: function () {
      this.isSSOAvailable()
    },

    isSSOAvailable: function () {
      ApiRequests.oktaAvailable().then(_ => {
        this.showSSOSettings = true
      }).catch(_ => {
        this.showSSOSettings = false
      })
    },

    logout: function () {
      AXIOSAPI.post('auth/logout').then(response => {
        removeCookie('token')
      }).catch(e => {
        console.error(e)
        // This appears twice and in the request repsonse so that there is no race condition
        // between deleting the cookie and sending the request that requires it
        removeCookie('token')
      })
      this.$router.push({name: 'login'})
    },

    getMaps: function () {
      ApiRequests.getMaps({ site: this.selectedSite._id })
      .then(r => { this.maps = r.data })
    },

    getItemLabel: function () {
      if (this.sSettings.itemLabel === '') return 'Items'
      return this.sSettings.itemLabel
    },

    getWorkerLabel: function () {
      if (this.sSettings.workerLabel === '') return 'Workers'
      return this.sSettings.workerLabel
    },

    getReports: function () {
      ApiRequests.reportConfigQuery({ site: this.selectedSite._id }).then(r => {
        this.reportConfigs = r.data
      })
    }
  }
}
</script>

<style>
.container {
  padding-bottom: 8px;
  padding-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue